import React from 'react';
import SideMenuDrawerListItem from './SideMenuDrawerListItem';
import MuiList, { ListProps as IMuiListProps } from '@mui/material/List';
import { compareURLSection } from '@tap/mui-ui';
import { styled } from '@mui/material/styles';
import { ISideMenuData } from './SideMenu.types';
import { useLocation } from 'react-router';

/*
*   Боковое меню: рендер списков бокового меню
*/

type ISideMenuDrawerList = {
    menuItemList?: ISideMenuData[],
}


const List = styled(MuiList)<IMuiListProps>(() => ({
    '& .MuiListItemButton-root': {
        color: '#999',
    },
    '& .MuiListItemButton-root > .MuiListItemIcon-root > *': {
        color: '#999',
        transition: 'color .195s',
    },
    '& .MuiListItemButton-root:hover > .MuiListItemIcon-root > *': {
        color: '#505f79',
        transition: 'color .195s',
    },
    '& .MuiSvgIcon-root': {
        marginLeft: '4px',
        color: '#999',
    },
    '& .Mui-selected > *': {
        color: '#505f79',
        '& .MuiSvgIcon-root': {
            color: '#505f79',
        },
    },
    '& .Mui-selected:hover': {
        color: '#505f79',
        backgroundColor: '#E4EBF4',
        opacity: 1,
    },
}));


export default function SideMenuDrawerList({ menuItemList }: ISideMenuDrawerList) {
    const { pathname } = useLocation();

    return (
        <List>
            {menuItemList?.map((item: ISideMenuData) => (
                <SideMenuDrawerListItem
                    key={item.label}
                    label={item.label}
                    icon={item.icon}
                    link={item.link}
                    selected={compareURLSection(pathname, item.link)}
                />
            ))}
        </List>
    );
} 